import React, { useRef, useState } from 'react'

import s from './styles.module.scss'

import {
  HouseCorporateEveningGlobalForm,
  HouseCorporateEveningGlobalFormProps,
} from './components/corporate-evening/HouseCorporateEveningGlobalForm'
import {
  HouseNightlyTripGlobalForm,
  HouseNightlyTripGlobalFormProps,
} from './components/nightly-trip/HouseNightlyTripGlobalForm'
import {
  HouseStudyDayGlobalForm,
  HouseStudyDayGlobalFormProps,
} from './components/study-day/HouseStudyDayGlobalForm'
import {
  HouseOptionsFormLayoutProps,
  HouseOptionsFormProps,
} from '../HouseOptionsForm'
import {
  HouseSeasonalBusynessCalendarForm,
  HouseSeasonalBusynessCalendarFormProps,
} from '../shared/components/seasonal-busyness-calendar/HouseSeasonalBusynessCalendarForm'
import { HouseOptionsMenusEnum } from '../shared/types/house-options.types'
import { HousePriceTypeEnum } from '../../../../lib/graphql'

export type HouseOptionsGlobalFormProps =
  HouseSeasonalBusynessCalendarFormProps &
    HouseNightlyTripGlobalFormProps &
    HouseStudyDayGlobalFormProps &
    HouseCorporateEveningGlobalFormProps
export const HouseOptionsGlobalForm = ({
  house,
  isDisabled,
  updateCorporateEveningGlobal,
  updateNightlyTripGlobal,
  updateSeasonalBusynessCalendar,
  updateStudyDayGlobal,
}: HouseOptionsGlobalFormProps & HouseOptionsFormProps) => {
  const [openedCard, setOpenedCard] = useState<HouseOptionsMenusEnum | null>(
    HouseOptionsMenusEnum.SEASONAL_BUSYNESS_CALENDAR,
  )

  const refMenu = useRef<HTMLDivElement>(null)

  const handleOpenedCards = (card: HouseOptionsMenusEnum) => {
    setOpenedCard(openedCard === card ? null : card)
  }

  const formProps: Omit<
    HouseOptionsFormLayoutProps,
    'handleOnExpand' | 'isOpen'
  > = {
    house,
    isDisabled,
    layoutProps: {
      parentHeight: refMenu.current?.clientHeight,
      numberOfCards: house.priceType === HousePriceTypeEnum.GLOBAL ? 6 : 5,
    },
  }

  return (
    <div className={s.containerHouseOptions} ref={refMenu}>
      <HouseSeasonalBusynessCalendarForm
        {...formProps}
        handleOnExpand={() =>
          handleOpenedCards(HouseOptionsMenusEnum.SEASONAL_BUSYNESS_CALENDAR)
        }
        isOpen={openedCard === HouseOptionsMenusEnum.SEASONAL_BUSYNESS_CALENDAR}
        updateSeasonalBusynessCalendar={updateSeasonalBusynessCalendar}
      />

      <HouseNightlyTripGlobalForm
        {...formProps}
        handleOnExpand={() =>
          handleOpenedCards(HouseOptionsMenusEnum.NIGHTLY_TRIP)
        }
        isOpen={openedCard === HouseOptionsMenusEnum.NIGHTLY_TRIP}
        updateNightlyTripGlobal={updateNightlyTripGlobal}
      />

      <HouseStudyDayGlobalForm
        {...formProps}
        handleOnExpand={() =>
          handleOpenedCards(HouseOptionsMenusEnum.STUDY_DAY)
        }
        isOpen={openedCard === HouseOptionsMenusEnum.STUDY_DAY}
        updateStudyDayGlobal={updateStudyDayGlobal}
      />

      <HouseCorporateEveningGlobalForm
        {...formProps}
        handleOnExpand={() =>
          handleOpenedCards(HouseOptionsMenusEnum.CORPORATE_EVENING)
        }
        isOpen={openedCard === HouseOptionsMenusEnum.CORPORATE_EVENING}
        updateCorporateEveningGlobal={updateCorporateEveningGlobal}
      />
    </div>
  )
}
